<template>
  <div class='purchaseSummary'>
    <div class='my-3 mb-5'>
      <p class="text-center">
          <i>Todas as funcionalidades do software HO Fácil Web sem nenhuma limitação.</i>
      </p>

      <div class="text-center" v-if="getAdditionalAccessQuantity > 0">
        <h6 class="mt-3"><strong>Detalhes da sua compra:</strong></h6>

        <ul style="list-style-position: inside">
          <li>
              <span >
                Usuário(s) subordinado(s):
                {{getAdditionalAccessQuantity}}
                un. por
                {{formatRealCurrent(parseFloat(totalPrice))}}
              </span>
          </li>
        </ul>

        <div v-if="payment.data.installments && (payment.data.installments == 2 || payment.data.installments == 3) && payment.method === 'credit_card'">
          <span >
            Foi escolhida a opção de parcelamento no cartão de crédito em {{payment.data.installments}} vezes:
          </span><br/><br/>

          <p>
            <strong>Total a pagar:</strong><br/>
            <strong class="total-pay">{{formatRealCurrent(totalPrice + calculateInterest)}}</strong>

            <span>
              <br/><strong>sendo</strong><br/>
              <strong class="total-pay">{{payment.data.installments}} x
                <span>{{ formatRealCurrent((totalPrice + calculateInterest) / payment.data.installments) }}</span>
              </strong>
            </span>
          </p>
        </div>

        <div v-else-if="payment.data.installments && payment.data.installments > 3 && payment.method === 'credit_card'">
          <p >
            Foi escolhida a opção de parcelamento no cartão de crédito em {{payment.data.installments}} vezes.
            Por isso, o valor total abaixo já inclui os juros do parcelamento.
          </p>

          <p>
            <strong>Total a pagar:</strong><br/>
            <strong class="total-pay">{{formatRealCurrent(totalPrice + calculateInterest)}}</strong>

            <span>
              <br/><strong>sendo</strong><br/>
              <strong class="total-pay">{{payment.data.installments}} x
                <span>{{ formatRealCurrent((totalPrice + calculateInterest) / payment.data.installments) }}</span>
              </strong>
            </span>
          </p>
        </div>

        <div v-else>
          <p>
            <strong>Total a pagar:</strong><br/>
            <strong class="total-pay" >{{formatRealCurrent(totalPrice)}}</strong>
          </p>
        </div>
      </div>

      <div class="mt-4" v-else>
        <p class="text-center">
          Preço visível após selecionar quantidade de usuários e tempo de acesso.
        </p>
      </div>
    </div>
    <footer>
      <span class='title'> Métodos de pagamento aceitos: </span>
      <div class='payment-flags my-3'>
        <img v-if="!payment.method || payment.method == 'bank_slip'" class='mb-1 mx-1' style='box-shadow: rgba(100, 100, 111, 0.2) 1px 2px 2px 1px; padding: 2px 5px; border-radius: 3px' width="56" height="36" alt='PIX' src='../../../assets/images/pagamento/pix.svg' />
        <img v-if="!payment.method || payment.method == 'credit_card'" alt='Amex' src='../../../assets/images/pagamento/amex.svg' />
        <img v-if="!payment.method || payment.method == 'credit_card'" alt='Dinner`s club' src='../../../assets/images/pagamento/dinners.svg' />
        <img v-if="!payment.method || payment.method == 'credit_card'" alt='ELO' src='../../../assets/images/pagamento/elo.svg' />
        <img v-if="!payment.method || payment.method == 'credit_card'" alt='Mastercard' src='../../../assets/images/pagamento/master.svg' />
        <img v-if="!payment.method || payment.method == 'credit_card'" alt='Visa' src='../../../assets/images/pagamento/visa.svg' />
      </div>
      <span class='by'>
        Ambiente e transações 100% seguros por
        <a href='https://iugu.com' target='_blank'>iugu</a>
      </span>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { formatRealCurrent } from '@/utils/format'

export default {
  name: 'PurchaseSummary',
  props: {},

  async mounted() {
  },
  data() {
    return {
      nextComponent: 'Payment',
      loading: false,
      taxaJuros: 1.49
    }
  },
  computed: {
    ...mapGetters('checkoutAccess', {
      totalPrice: 'totalPrice',
      getAdditionalAccessQuantity: 'additionalAccessQuantity',
      interestCharged: 'interestCharged'
    }),
    ...mapGetters('checkout2', {
      payment: 'getPayment'
    }),
    calculateInterest() {
      let interestCharged = 0
      if (this.payment.data.installments > 3 && this.payment.method === 'credit_card') {
        interestCharged = Number(((this.totalPrice * Math.pow(1 + this.taxaJuros / 100, this.payment.data.installments)) - this.totalPrice).toFixed(2))
      }
      this.handleSetInterestCharged(interestCharged)
      return interestCharged
    }
  },
  methods: {
    ...mapActions('checkoutAccess', {
      handleSetInterestCharged: 'handleSetInterestCharged'
    }),
    formatRealCurrent,
    async next() {
      this.$emit('set-component', this.nextComponent)
    }
  },
  watch: {
    "payment.data.installments"(){
      if (this.payment.data.installments <= 3) {
        this.handleSetInterestCharged(0)
      }
    }
  },

}
</script>

<style lang='scss' scoped>
.purchaseSummary {
  background: #FFFFFF;
  border-radius: 10px;
}

.loading {
  position: absolute;
  margin-left: -30px;
  margin-top: 12px;
  width: 1.5rem;
  height: 1.5rem;
}

.btn-radio {
  display: flex;
  flex-direction: row;

  .form-radio {
    padding: 5px;
    cursor: pointer !important;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}

.numberAccesses {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #022245;
}
.total-pay{
  font-size: 26px;
  font-weight: bold;
}
</style>
